<template>
  <CustomCreateDialog
      :dialogTitle="isEditing ? 'ویرایش رکورد تاریخچه' : 'افزودن رکورد جدید'"
      dialogId="create-history-modal"
      :isOkDisabled="!isValid || submitting"
      :isLoading="submitting"
      :ok-title="isEditing ? 'ویرایش' : 'افزودن'"
      @ok="submit"
      width="800px"
      maxWidth="95vw"
      minWidth="300px"
  >
    <b-form @submit.prevent>
      <b-row>
        <b-col v-if="!isEditing" cols="12" md="6">
          <b-form-group>
            <template #label>
              <label class="hm-label required">
                <feather-icon icon="CalendarIcon" size="14" />
                تاریخ هدف
              </label>
            </template>

            <CustomDate
                v-model="form.targetDate"
                inputId="historyTargetDate"
                inputPlaceholder="انتخاب تاریخ"
                :disabled="submitting"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label-class="hm-label">
            <template #label>
              <label class="hm-label">
                <feather-icon icon="ClockIcon" size="14" />
                زمان کلاس برنامه‌ای
              </label>
            </template>

            <b-form-input
                v-model.number="form.scheduleTotal"
                type="number"
                min="0"
                step="0.1"
                class="hm-input"
                placeholder="0"
                :disabled="submitting"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label-class="hm-label">
            <template #label>
              <label class="hm-label">
                <feather-icon icon="UsersIcon" size="14" />
                زمان کلاس گروهی
              </label>
            </template>

            <b-form-input
                v-model.number="form.groupClassTotal"
                type="number"
                min="0"
                step="0.1"
                class="hm-input"
                placeholder="0"
                :disabled="submitting"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label-class="hm-label">
            <template #label>
              <label class="hm-label">
                <feather-icon icon="TrendingUpIcon" size="14" />
                زمان کلاس ترمیک
              </label>
            </template>

            <b-form-input
                v-model.number="form.termicClassTotal"
                type="number"
                min="0"
                step="0.1"
                class="hm-input"
                placeholder="0"
                :disabled="submitting"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label-class="hm-label">
            <template #label>
              <label class="hm-label">
                <feather-icon icon="HeadphonesIcon" size="14" />
                زمان پشتیبانی
              </label>
            </template>

            <b-form-input
                v-model.number="form.supportTotal"
                type="number"
                min="0"
                step="0.1"
                class="hm-input"
                placeholder="0"
                :disabled="submitting"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label-class="hm-label" :state="descriptionState">
            <template #label>
              <label :class="['hm-label', { required: isEditing }]">
                <feather-icon icon="FileTextIcon" size="14" />
                توضیحات
              </label>
            </template>

            <b-form-textarea
                v-model.trim="form.description"
                class="hm-textarea"
                rows="3"
                :placeholder="isEditing ? 'توضیحات را وارد کنید...' : 'توضیحات اضافی (اختیاری)...'"
                :disabled="submitting"
                :state="descriptionState"
                :aria-invalid="descriptionState === false ? 'true' : null"
            />

<!--            <b-form-invalid-feedback :state="descriptionState">-->
<!--              لطفا توضیحات خود را وارد کنید-->
<!--            </b-form-invalid-feedback>-->
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <template #modal-footer>
      <div class="hm-footer">
        <b-button
            variant="outline-secondary"
            class="hm-btn hm-btn--ghost"
            :disabled="submitting"
            @click="show = false"
        >
          <feather-icon icon="XIcon" size="16" />
          انصراف
        </b-button>

        <b-button
            variant="success"
            class="hm-btn hm-btn--primary"
            :disabled="submitting || !isValid"
            @click="submit"
        >
          <span v-if="submitting" class="hm-spinner"></span>
          <feather-icon v-else icon="CheckIcon" size="16" />
          {{ submitting ? "در حال ثبت..." : isEditing ? "ویرایش" : "ثبت" }}
        </b-button>
      </div>
    </template>
  </CustomCreateDialog>
</template>

<script>
import {
  BModal,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormInvalidFeedback,
  BButton
} from "bootstrap-vue";
import {
  CreateHistoryLevelLoyaltUser,
  UpdateHistoryLevelLoyaltUser
} from "@/libs/Api/LevelLoyalty";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import CustomDate from "@/views/components/Utils/CustomDatePicker.vue";

export default {
  name: "CreateHistoryModal",
  components: {
    CustomCreateDialog,
    CustomDate,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BButton
  },
  props: {
    value: { type: Boolean, default: false },
    levelLoyaltyUserId: { type: Number, default: 0 },
    submitting: { type: Boolean, default: false }
  },
  data() {
    return {
      editingItem: null,
      form: {
        targetDate: "",
        scheduleTotal: 0,
        groupClassTotal: 0,
        termicClassTotal: 0,
        supportTotal: 0,
        description: ""
      }
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    isEditing() {
      return !!(this.editingItem && Number(this.editingItem.id || 0) > 0);
    },
    descriptionRequired() {
      return this.isEditing;
    },
    descriptionOk() {
      if (!this.descriptionRequired) return true;
      return String(this.form.description || "").trim().length > 0;
    },
    descriptionState() {
      if (!this.descriptionRequired) return null;
      return this.descriptionOk;
    },
    isValid() {
      if (this.isEditing) {
        return this.levelLoyaltyUserId > 0 && this.descriptionOk;
      }
      const dateOk = String(this.form.targetDate || "").trim().length > 0;
      return dateOk && this.levelLoyaltyUserId > 0;
    }
  },
  methods: {
    openForCreate() {
      this.editingItem = null;
      this.form = {
        targetDate: "",
        scheduleTotal: 0,
        groupClassTotal: 0,
        termicClassTotal: 0,
        supportTotal: 0,
        description: ""
      };
    },
    openForEdit(item) {
      this.editingItem = item;
      this.form = {
        targetDate: "",
        scheduleTotal: Number(item?.scheduleTotal || 0),
        groupClassTotal: Number(item?.groupClassTotal || 0),
        termicClassTotal: Number(item?.termicClassTotal || 0),
        supportTotal: Number(item?.supportTotal || 0),
        description: ""
      };
    },
    reset() {
      this.editingItem = null;
      this.form = {
        targetDate: "",
        scheduleTotal: 0,
        groupClassTotal: 0,
        termicClassTotal: 0,
        supportTotal: 0,
        description: ""
      };
    },
    convertToISODate(dateString) {
      if (!dateString) return null;
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return null;
      return date.toISOString();
    },
    buildPayload() {
      if (this.isEditing && !this.descriptionOk) {
        throw new Error("وارد کردن توضیحات در حالت ویرایش اجباری است");
      }

      const payload = {
        levelLoyaltyUserHistoryId: Number(
            this.editingItem?.levelLoyaltyUserHistoryId || this.editingItem?.id || 0
        ),
        scheduleTotal: Number(this.form.scheduleTotal || 0),
        groupClassTotal: Number(this.form.groupClassTotal || 0),
        termicClassTotal: Number(this.form.termicClassTotal || 0),
        supportTotal: Number(this.form.supportTotal || 0),
        description: String(this.form.description || "").trim()
      };

      if (!this.isEditing) {
        const isoDate = this.convertToISODate(this.form.targetDate);
        if (!isoDate) throw new Error("تاریخ معتبر نیست");
        payload.targetDate = isoDate;
        payload.levelLoyaltyUserId = this.levelLoyaltyUserId;
      }

      return payload;
    },
    onHidden() {
      this.reset();
      this.$emit("hidden");
    },
    async createRecord(payload) {
      const request = new CreateHistoryLevelLoyaltUser(this);
      request.setRequestParamDataObj(payload);
      const response = await new Promise((resolve, reject) => {
        request.send(resolve, reject);
      });
      if (!response || !response.isSuccess) {
        throw new Error(response?.errors || "ایجاد رکورد انجام نشد");
      }
      return response;
    },
    async updateRecord(payload) {
      const request = new UpdateHistoryLevelLoyaltUser(this);
      request.setRequestParamDataObj(payload);
      const response = await new Promise((resolve, reject) => {
        request.send(resolve, reject);
      });
      if (!response || !response.isSuccess) {
        throw new Error(response?.errors || "ویرایش رکورد انجام نشد");
      }
      return response;
    },
    async submit() {
      if (!this.isValid) return;
      try {
        const payload = this.buildPayload();
        this.$emit("submit", payload);
      } catch (error) {
        this.$emit("error", error.message);
      }
    }
  }
};
</script>

<style scoped>
.hm-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  margin: -20px -24px 20px;
}

.hm-head__title {
  font-size: 18px;
  font-weight: 900;
  color: #111827;
}

.hm-head__close {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #f3f4f6;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hm-head__close:hover:not(:disabled) {
  background: #e5e7eb;
  color: #374151;
}

.hm-head__close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.hm-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 10px;
}

.hm-label.required::after {
  content: "*";
  color: #dc2626;
  margin-right: 4px;
}

.hm-input {
  height: 48px;
  border-radius: 14px;
  border: 2px solid #e5e7eb;
  font-weight: 600;
  font-size: 14px;
  padding: 0 16px;
  transition: all 0.2s ease;
}

.hm-input:focus {
  border-color: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.08);
}

.hm-input:disabled {
  background: #f9fafb;
  cursor: not--allowed;
}

.hm-textarea {
  border-radius: 14px;
  border: 2px solid #e5e7eb;
  font-weight: 600;
  font-size: 14px;
  padding: 12px 16px;
  transition: all 0.2s ease;
  resize: vertical;
}

.hm-textarea:focus {
  border-color: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.08);
}

.hm-error {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #dc2626;
}

.hm-footer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
  margin-top: 20px;
}

.hm-btn {
  height: 48px;
  border-radius: 14px;
  font-weight: 700;
  font-size: 14px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.hm-btn--ghost {
  border: 2px solid #e5e7eb;
  background: #fff;
}

.hm-btn--ghost:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #d1d5db;
}

.hm-btn--primary {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  border: none;
  box-shadow: 0 4px 16px rgba(34, 197, 94, 0.2);
  color: #fff;
}

.hm-btn--primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(34, 197, 94, 0.3);
}

.hm-btn--primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.hm-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
